<template>
    <div class="screensaver">
        <div class="screensaver-header">
            <!--            <div class="screensaver-header-left">
                            <span class="logo">Test</span>
                        </div>-->
        </div>
        <div class="screensaver-body">
            <video controls id="vid" class="video">
                <source src="@/assets/video/promo/video.mp4" type="video/mp4">
            </video>
            <!--            <iframe id="video" src="//www.youtube.com/embed/N23Q-X2Zh3s?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>-->
            <img src="@/assets/video/promo/video_preview.png" class="preview-img" v-if="show_play"/>
            <div class="screensaver-body-center">
                <b-button @click="playVideo()" class="play-btn" v-if="show_play">Play</b-button>
            </div>
        </div>
    </div>
</template>

<script>
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapState} from 'vuex';

export default {
    mixins: [mixin, errorMixin],
    components: {},
    data() {
        return {
            show_play: true,
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    async mounted() {
        document.title = "Happy Father's Day"
    },
    methods: {
        ...mapActions({}),
        playVideo() {
            this.show_play = false
            var elem = document.getElementsByTagName('video')[0];
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            }
            elem.play();
        }
    }

}
</script>

<style>

</style>
<style scoped>
.screensaver {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: gray;
    z-index: 9000;
}

.logo {
    /*background-image: url(~@/assets/test.svg);*/
}

.screensaver-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.00) 100%);
    z-index: 1500;
    display: flex;
    align-items: center;
    padding: 10px;
}

.screensaver-header-left {
    flex: 0 0 320px;
}

.screensaver-body {
    top: 0;
    position: absolute;
    height: 100vh;
    width: 100vw;
}

video {
    min-height: 100%;
    min-width: 100%;
    height: 100vh;
    display: block;
}

.screensaver-body-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
}
.preview-img {
    position: absolute;
    top: 0;
    width: auto;
    object-fit: cover;
    min-height: 100%;
}
.play-btn {
    width: 250px;
    height: 50px;
    font-size: 20px;
    background: #e7e7e7;
    color: #282828;
    border: none;
}
</style>
